import {
  Box,
  FormControl,
  FormControlLabel,
  FormGroup,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  TextField,
  Typography
} from "@mui/material";
import { DateTimePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import { useState } from "react";
import { THungerGame, TPizzaMenu } from "../../types/AllTypes";
import { toIsoString } from "../../utils";
import { MyButton } from "../MyButton";
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault("Europe/Bratislava");

export const HungerGameForm = ({
  hungerGame,
  onChange: aOnChange,
  onSave,
  inDrawer = true,
  getPizzaMenuWithId,
  pizzaMenus,
  allowFinished = true,
  allowAllowGuests: allowGuestMode = true
}: {
  hungerGame: THungerGame;
  onChange: <T extends keyof THungerGame>(
    fieldChanged: T,
    newValue: THungerGame[T]
  ) => void;
  onSave: () => Promise<boolean>;
  inDrawer?: boolean;
  getPizzaMenuWithId: (id: string | number) => TPizzaMenu | undefined;
  pizzaMenus: TPizzaMenu[];
  allowAllowGuests?: boolean;
  allowFinished?: boolean;
}) => {
  const [changed, setChanged] = useState(false);
  const onChange = <T extends keyof THungerGame>(
    fieldChanged: T,
    newValue: THungerGame[T]
  ) => {
    setChanged(true);
    aOnChange(fieldChanged, newValue);
  };
  const toggleFinished = () => {
    onChange("finished", !hungerGame.finished);
  };
  const toggleAllowGuests = () => {
    onChange("allowGuests", !hungerGame.allowGuests);
  };
  return (
    <>
      <Box
        padding={3}
        marginBottom={inDrawer ? 5 : 1}
        paddingBottom={inDrawer ? 10 : 3}
        paddingTop={inDrawer ? 0 : 3}
      >
        <FormGroup>
          <TextField
            sx={{ margin: 1 }}
            value={hungerGame.name}
            onChange={e => onChange("name", e.target.value)}
            label="Name"
            variant="standard"
            fullWidth
          />
          <DateTimePicker
            sx={{ margin: 1 }}
            label="Deadline"
            value={dayjs(toIsoString(hungerGame.deadline))}
            onChange={e =>
              onChange("deadline", e?.toDate() ?? hungerGame.deadline)
            }
            minutesStep={1}
            ampm={false}
          />
          {/* <input
            name="deadline"
            type="datetime-local"
            value={hungerGame.deadline.toISOString().replace("Z", "")}
            onChange={(e) => onChange("deadline", new Date(e.target.value))}
          /> */}
          <TextField
            sx={{ margin: 1 }}
            value={hungerGame.pizzaLocation}
            onChange={e => onChange("pizzaLocation", e.target.value)}
            label="Pizza location"
            helperText="Zadaj až keď pizza príde"
            variant="standard"
            fullWidth
          />
          {/* <FormControl fullWidth sx={{ margin: 1 }}>
            <InputLabel id="toggle-finished-label">Finished</InputLabel>
            <Switch labelId="toggle-finished-label" checked={hungerGame.finished} onChange={toggleFinished} />
          </FormControl> */}
          <FormControlLabel
            sx={{
              margin: 1,
              marginRight: 0,
              justifyContent: "space-between"
            }}
            control={
              <Switch
                checked={hungerGame.finished}
                onChange={toggleFinished}
                disabled={!allowFinished}
              />
            }
            label="Finished"
            labelPlacement="start"
          />
          {/* <input
            name="finished"
            type="checkbox"
            value={hungerGame.finished}
            onChange={(e) => onChange("finished", e.target.value)}
          /> */}
          <TextField
            sx={{ margin: 1 }}
            value={hungerGame.infoText}
            onChange={e => onChange("infoText", e.target.value)}
            label="Info text"
            variant="standard"
            fullWidth
          />
          <DateTimePicker
            sx={{ margin: 1 }}
            label="ETA"
            value={dayjs(toIsoString(hungerGame.eta))}
            onChange={e => onChange("eta", e?.toDate() ?? hungerGame.eta)}
            minutesStep={1}
            ampm={false}
          />
          <TextField
            sx={{ margin: 1 }}
            value={hungerGame.iban}
            onChange={e => onChange("iban", e.target.value)}
            label="Iban uctu"
            helperText="Doprovolne (Povinne pre QR a Payme link)"
            variant="standard"
            fullWidth
          />
          <TextField
            sx={{ margin: 1 }}
            value={hungerGame.creditorName}
            onChange={e => onChange("creditorName", e.target.value)}
            label="Meno prijímateľa"
            helperText="Doprovolne (Povinne pre Payme link)"
            variant="standard"
            fullWidth
          />
          <FormControl fullWidth sx={{ margin: 1 }}>
            <InputLabel id="select-pizza-menu-label">Pizza menu</InputLabel>
            <Select
              labelId="select-pizza-menu-label"
              id="select-pizza-menu"
              value={hungerGame.pizzaMenu.id}
              label="Pizza menu"
              onChange={e => {
                const menu = getPizzaMenuWithId(e.target.value);
                if (menu) onChange("pizzaMenu", menu);
              }}
            >
              {pizzaMenus.map(menu => {
                return (
                  <MenuItem key={menu.id} value={menu.id}>
                    {menu.name}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
          <FormControlLabel
            sx={{
              margin: 1,
              marginRight: 0,
              justifyContent: "space-between"
            }}
            control={
              <Switch
                checked={hungerGame.allowGuests}
                onChange={toggleAllowGuests}
                disabled={!allowGuestMode}
              />
            }
            label="Allow guests"
            labelPlacement="start"
          />
          {/* <input
            name="eta"
            type="datetime-local"
            value={hungerGame.eta.toISOString().replace("Z", "")}
            onChange={(e) => onChange("eta", new Date(e.target.value))}
          /> */}
        </FormGroup>
      </Box>
      <Box
        position={inDrawer ? "fixed" : "inherit"}
        bottom={inDrawer ? 20 : 60}
        marginBottom={inDrawer ? 0 : 3}
        width={"100%"}
        paddingX={2}
      >
        <MyButton
          sx={{ width: "100%" }}
          onClick={() =>
            onSave().then(s => {
              if (s) setChanged(false);
            })
          }
          disabled={!changed}
        >
          <Typography
            sx={{
              fontWeight: 700
            }}
            variant="h6"
          >
            ULOZIT
          </Typography>
        </MyButton>
      </Box>
    </>
  );
};
